import SponsorCard from "components/Card/SponsorCard";
import { sponsorsData } from "constant/sponsors";
import React from "react";

const SponsorSection = () => {
  const firstCards = sponsorsData.slice(0, 1);
  const secondCards = sponsorsData.slice(1);

  return (
    <div className="flex flex-col items-center -mt-6">
      <div className="font-yesevaOne text-xl sm:text-5xl text-wce-pink-bright mx-auto mb-6 sm:mb-14">
        Our Company & Media Partners
      </div>
      <div className="bg-white shadow-wce-hard rounded-2xl w-full max-w-[1248px] md2:mx-8 p-4 sm:p-10">
        <div className="grid justify-self-center mb-3 sm:mb-10">
          {firstCards?.map((sponsor) => (
            <SponsorCard sponsor={sponsor} order={"1"} />
          ))}
        </div>
        <div
          className="grid gap-3 sm:gap-x-14 sm:gap-y-10
            grid-cols-[repeat(auto-fill,_minmax(48px,_1fr))]
            sm:grid-cols-[repeat(auto-fill,_minmax(160px,_1fr))]"
        >
          {secondCards?.map((sponsor) => (
            <SponsorCard sponsor={sponsor} order={"2"} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default SponsorSection;
